import React, { useState, useEffect, useRef } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Text } from '../../components/Text';
import { Button, Col, Row, Pagination } from 'react-bootstrap';
import { Modal, Box, Tooltip, TableSortLabel, TableContainer, TableHead, TableRow, TableCell, TableBody, Paper, Typography, LinearProgress, Autocomplete, TextField, CircularProgress, InputAdornment } from '@mui/material';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { Title } from '../../components/Title';
import { Badge } from 'react-bootstrap';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import './styles.css'
import { StatusDocumento } from '../../constants/statusDocumento';
import { NiveisAcesso } from '../../constants/niveisAcesso';
import errorIcon from '../../img/icon/Error.svg'
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import _ from 'lodash';
import RedoIcon from '@mui/icons-material/Undo';

export function Documentos() {
    const [isLoading, setIsLoading] = useState(false);
    const [nivelAcesso, setNivelAcesso] = useState(0);
    const [companies, setCompanies] = useState<any>([]);
    const [data, setData] = useState<any>();
    const [filePath, setFilePath] = useState<any>();
    const [observations, setObservations] = useState<any>();
    const [selectedDocumentId, setSelectedDocumentId] = useState<any>();
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [showAccessModal, setShowAccessModal] = useState(false);
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [showHelp2Modal, setShowHelp2Modal] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [base64PDF, setBase64PDF] = useState('');
    const [selectedFileName, setSelectedFileName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [progressModalOpen, setProgressModalOpen] = useState(false);
    const [progressValue, setProgressValue] = useState(0);
    const [show, setShow] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [error, setError] = useState("");
    const [inputValue, setInputValue] = useState<string>('');
    const [adminPrimeiroAcesso, setAdminPrimeiroAcesso] = useState(false);

    useEffect(() => {
        api.get('nivel-acesso').then((response: any) => {
            setNivelAcesso(response.data.nivel)
            // Ao renderizar, se o usuário for o admin, lista todos os documentos
            if (response.data.nivel === 4) listarTodosOsDocumentos();
            setAdminPrimeiroAcesso(true);
        });
    }, [])

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                if (nivelAcesso === NiveisAcesso.CLIENTE || nivelAcesso === NiveisAcesso.PARCEIRO || (!adminPrimeiroAcesso && nivelAcesso === NiveisAcesso.ADMIN)) {
                    handleSearchCompanyFiles(selectedCompany);
                } else {
                    loadCompanies();
                    handleSearchFiles();
                }
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [nivelAcesso, selectedCompany]);

    const listarTodosOsDocumentos = async () => {
        const response = await api.get('getAllFiles');
        setData(response.data.data);
    }

    const downloadDocument = async (docId: number, doc_section: string, companyName: string) => {
        setIsLoading(true);
        try {
            const response = await api.get(`get-file/${docId}`);
            const responseData = response.data;
            const pdfBase64 = responseData.data;

            const linkSource = `data:application/pdf;base64,${pdfBase64}`;
            const downloadLink = document.createElement("a");

            const formatCompanyName = companyName.replace(/\s+/g, '_');
            const fileName = `${formatCompanyName}_${docId}_${doc_section}.pdf`;

            document.body.appendChild(downloadLink);
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
            document.body.removeChild(downloadLink);
        } catch (error) {
            console.error("Error downloading document:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const downloadSignedDocument = async (documentId: number) => {
        setIsLoading(true)
        const response1 = await api.get(`getFileById/${documentId}`);
        const responseData1 = response1.data;
        try {

            const response = await api.get(`getSignedFile/${documentId}`);
            const responseData = response.data;

            const pdfPath = responseData.data;

            const linkSource = `data:application/pdf;base64,${pdfPath}`;
            const downloadLink: any = document.createElement("a");
            document.body.appendChild(downloadLink);
            downloadLink.href = linkSource;
            downloadLink.download = Date.now();
            downloadLink.click();
            document.body.removeChild(downloadLink);

        } catch (error) {
            console.error("Error downloading document:", error);
        } finally {
            setIsLoading(false)
        }
    };

    const loadCompanies = async () => {
        try {
            const response = await api.get('empresas');
            setCompanies(response.data.message ? [] : response.data);
            // Se o usuário logado não for o admin, seta a empresa retornada como selecionada
            if (nivelAcesso !== NiveisAcesso.ADMIN) setSelectedCompany(response.data.length > 0 ? response.data[0].id : null);
            if (nivelAcesso === NiveisAcesso.ADMIN) setSelectedCompany(null);
        } catch (error) {
            console.error("Error fetching companies:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSearchFiles = async () => {
        try {
            const response = await api.get('getAllFiles');
            const responseData = response.data;
            const documentsWithState = responseData.data.map((doc: any) => ({
                ...doc,
                file: null,
                observations: ''
            }));
            setData(documentsWithState);
            setFilePath(responseData.data);
        } catch (error) {
            console.error("Error fetching documents:", error);
        }
    }


    const handleSearchSignedFiles = async (id: any) => {
        try {
            const response = await api.get(`getAllSignedFiles/${id}`);
            const responseData = response.data;
            if (responseData.data.length !== 0) {
                if (data.length > 1) {
                    const signedDataMap = new Map(responseData.data.map((signedItem: { document_id: any; }) => [signedItem.document_id, signedItem]));
                    const updatedData = data.map((item: { id: any; }) => {
                        const signedItem = signedDataMap.get(item.id);
                        return signedItem ? { ...item, ...signedItem } : item;
                    });
                    setData(updatedData);
                    setFilePath(updatedData);
                }

            } else {
                return
            }
        } catch (error) {
            console.error("Error fetching signed documents:", error);

        }
    }

    const handleSearchCompanyFiles = async (id: any) => {
        try {
            const response = await api.get(`getAllFilesById/${id}`);
            const responseData = response.data;
            if (responseData.data) {
                setData(responseData.data);
                setFilePath(responseData.data);
                handleSearchSignedFiles(id);
            } else {
                setAlert({ show: true, message: 'Erro ao buscar documentos para esta empresa.', variant: 'danger' });
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching signed documents:", error);
        }
    }



    const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} às ${(date.getHours()).toString().padStart(2, '0')}h${date.getMinutes().toString().padStart(2, '0')}`;
        return formattedDate;
    };

    const handleCloseAccessModal = () => {
        setSelectedFileName('');
        setShowAccessModal(false);
    };

    const handleCloseHelpModal = () => {
        setShowHelpModal(false);
    };

    const handleCloseHelp2Modal = () => {
        setShowHelp2Modal(false);
    };

    const handleCloseRejectModal = () => {
        setShowRejectModal(false);
        setObservations('');
    };

    const buttonStyle = {
        width: '150px',
        fontSize: '15px',
        padding: '10px 0px',
        borderRadius: '5px',
        border: 'none',
    };


    const handleFileChange = (event: any) => {
        let file = event.target.files[0];
        if (file) {
            setSelectedFileName(file.name);
            const reader = new FileReader();
            reader.onloadend = () => {
                if (typeof reader.result === 'string') {
                    setBase64PDF(reader.result);
                }
            };
            reader.readAsDataURL(file);
        }
    };

    const simulateProgress = () => {
        let progress = 0;
        const interval = setInterval(() => {
            if (progress < 95) {
                progress += 0.2;
                setProgressValue(progress);
            } else {
                clearInterval(interval);
            }
        }, 100);
    };

    const handleFileSave = async () => {
        setShowAccessModal(false);
        setProgressModalOpen(true);
        simulateProgress()
        const response = await api.get(`getFileById/${selectedDocumentId}`);
        const responseData = response.data;

        if (!base64PDF) {
            console.error("Nenhum arquivo selecionado para upload");
            return;
        }

        // Criação do formData deve ser feita antes de adicionar os dados
        const formData = new FormData();

        const fileName = `document_${selectedDocumentId}_${responseData.data[0].company_id}_assinado.pdf`;

        // Checa se base64PDF é realmente uma string base64 e a converte em Blob
        if (typeof base64PDF === 'string' && base64PDF.startsWith('data:')) {
            const byteString = atob(base64PDF.split(',')[1]);
            const mimeString = base64PDF.split(',')[0].split(':')[1].split(';')[0];

            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            const blob = new Blob([ab], { type: mimeString });
            formData.append('file', blob, fileName);
        } else {
            console.error("O arquivo selecionado não é um Base64 válido.");
            return;
        }

        formData.append('fileName', fileName);
        formData.append('documentId', selectedDocumentId);
        formData.append('idEmpresa', responseData.data[0].company_id);
        formData.append('userEmail', userEmail)

        try {
            const response = await api.post('saveSignedPDF', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.status === 200) {
                console.log("Upload bem-sucedido");
                const dataType = {
                    status: 2,
                    id: selectedDocumentId,
                };
                await api.post('updateDocType', dataType);
                const responseFiles = await api.get('getAllFiles');
                const responseFilesData = responseFiles.data;
                setData(responseFilesData.data)
                setProgressValue(0);
                setProgressModalOpen(false);
                setSelectedFileName('');
                setBase64PDF('');
            }
        } catch (error) {
            console.error("Erro ao fazer upload do PDF:", error);
        }
    };

    const handleAttachDocument = (documentId: number, user_email: string) => {
        setSelectedDocumentId(documentId);
        setUserEmail(user_email);
        setShowAccessModal(true);
    };

    const handleRejectButtonDocument = (documentId: number) => {
        setSelectedDocumentId(documentId);
        setShowRejectModal(true);
    };

    const handleShowAlert = () => {
        setError("Por favor, faça o upload de um arquivo");
        console.log('teste')
    };

    const handleRejectDocument = async () => {
        try {
            const dataType = {
                status: 3,
                id: selectedDocumentId,
                observations: observations
            };
            await api.post('rejectDocType', dataType);
            const responseFiles = await api.get('getAllFiles');
            const responseFilesData = responseFiles.data;
            setData(responseFilesData.data)
            setShowRejectModal(false)
        } catch (error) {
            console.log(error)
        }
    }

    const removeCNPJMask = (cnpj: string) => cnpj.replace(/[\.\-\/\s]/g, '');

    const filterOptions = (options: any, inputValue: string) => {
        if (!inputValue) return options;
        if (inputValue.length < 2) return options;
        const inputLimpo = removeCNPJMask(inputValue).toUpperCase();
        return options.filter((option: any) => {
            if (/^[A-Z0-9]+$/.test(inputLimpo)) {
                return removeCNPJMask(option.cnpj).toUpperCase().includes(inputLimpo);
            } else {
                return option.nome.toLowerCase().includes(inputValue.toLowerCase());
            }
        });
    };

    const handleAutocompleteOnChange = (newValue: any) => {
        if (adminPrimeiroAcesso) setAdminPrimeiroAcesso(false);
        if (newValue) {
            // Se uma nova opção for selecionada
            setSelectedCompany(newValue.id);
            setInputValue(`${newValue.nome} - ${newValue.cnpj}`);
        } else if (nivelAcesso === 4) {
            // Se não houver nova opção selecionada (campo limpo) e o nível de acesso for admin
            setInputValue('');
            listarTodosOsDocumentos();
        }
    }

    const handleAutocompleteOnInputChange = (inputValue: any, reason: any) => {
        if (reason === 'clear') {
            handleAutocompleteOnChange(null);
        } else {
            setInputValue(inputValue);
        }
    }

    const tratarLabelExibicaoAutocomplete = (option: any) => {
        if (option.length === 1 || typeof option === 'number') {
            const empresaEncontrada = companies.find((company: { id: number; }) => company.id === parseInt(option));
            if (!empresaEncontrada) return '';
            return `${empresaEncontrada.nome} - ${formatCNPJ(empresaEncontrada.cnpj)}`;
        } else {
            return `${option.nome} - ${formatCNPJ(option.cnpj)}`;
        }
    };


    const formatCNPJ = (cnpj: any) => {
        const cleanCNPJ = cnpj.replace(/[\.\-\/\s]/g, '').toUpperCase();

        if (cleanCNPJ.length !== 14) {
            return cnpj;
        }

        return `${cleanCNPJ.substring(0,2)}.${cleanCNPJ.substring(2,5)}.${cleanCNPJ.substring(5,8)}/${cleanCNPJ.substring(8,12)}-${cleanCNPJ.substring(12,14)}`;
    };

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                {nivelAcesso === NiveisAcesso.RESPONSAVEL ? (
                    <CardContent>
                        <Row className='my-4'>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%'
                            }}>
                                <Title text="Análise de Documentos" />
                                <Button
                                    style={{
                                        width: '40px',
                                        borderRadius: '20px',
                                    }}
                                    onClick={() => setShowHelpModal(true)}>
                                    ?
                                </Button>
                            </Box>
                        </Row>
                        <Row className='mb-4'>
                        </Row>
                        <Row className='documento-container'>
                            <table>
                                <thead>
                                    <tr className='documento-tabela-header'>
                                        <th className='documento-tabela-header-celula'>Status</th>
                                        <th className='documento-tabela-header-celula'>Documento</th>
                                        <th className='documento-tabela-header-celula'>Usuário</th>
                                        <th className='documento-tabela-header-celula'>Data</th>
                                        <th className='documento-tabela-header-celula'>Assinar Documento</th>
                                        <th className='documento-tabela-header-celula'>Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data && data.length > 0 ? (
                                        data.map((pgr_docs: any) => {
                                            return (
                                                <tr key={pgr_docs.id}>
                                                    <td className='documento-celula'>
                                                        {pgr_docs.doc_type === StatusDocumento.PENDENTE_ASSINATURA ? (
                                                            <Badge pill style={{ width: '180px' }} className="badge-orange">
                                                                <NewReleasesIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                {pgr_docs.type_name}
                                                            </Badge>
                                                        ) : pgr_docs.doc_type === StatusDocumento.ASSINADO ? (
                                                            <Badge bg="success" pill style={{ width: '180px' }}>
                                                                <CheckCircleOutlineIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                {pgr_docs.type_name}
                                                            </Badge>
                                                        ) : pgr_docs.doc_type === StatusDocumento.RECUSADO ? (
                                                            <Badge bg="danger" pill style={{ width: '180px' }}>
                                                                <ThumbDownOffAltIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                {pgr_docs.type_name}
                                                            </Badge>
                                                        ) : pgr_docs.doc_type === StatusDocumento.QUARENTENA ? (
                                                            <Badge bg="danger" pill style={{ width: '180px' }}>
                                                                <ThumbDownOffAltIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                {pgr_docs.type_name}
                                                            </Badge>
                                                        ) : pgr_docs.doc_type === StatusDocumento.RETORNADO ? (
                                                            <Badge bg="warning" pill style={{ width: '180px' }}>
                                                                <RedoIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                {pgr_docs.type_name}
                                                            </Badge>
                                                        ) : (
                                                            null
                                                        )}
                                                    </td>
                                                    <td className='documento-celula'>
                                                        {pgr_docs.doc_section}
                                                    </td>
                                                    <td className='documento-celula'>
                                                        Enviado por {pgr_docs.user_email}
                                                    </td>
                                                    <td className='documento-celula'>
                                                        Enviado em {formatDate(pgr_docs.updated_at)}
                                                    </td>
                                                    <td className='documento-celula'>
                                                        {pgr_docs.doc_type !== StatusDocumento.QUARENTENA ? (
                                                            <>
                                                                {pgr_docs.doc_type === StatusDocumento.ASSINADO ? (
                                                                    <Button style={{ ...buttonStyle, background: '#C0C0C0' }}>Anexar Documento</Button>
                                                                ) : (
                                                                    <Button onClick={() => handleAttachDocument(pgr_docs.id, pgr_docs.user_email)} style={buttonStyle}>Anexar Documento</Button>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <>Não é possível assinar um <br />documento em quarentena</>
                                                        )}
                                                    </td>
                                                    <td className='documento-celula'>
                                                        {pgr_docs.doc_type !== StatusDocumento.QUARENTENA ? (
                                                            <>
                                                                {pgr_docs.doc_type === StatusDocumento.ASSINADO ? (
                                                                    <Button onClick={() => downloadSignedDocument(pgr_docs.id)} style={buttonStyle}>Baixar Documento</Button>
                                                                ) : (
                                                                    <Button onClick={() => downloadDocument(pgr_docs.id, pgr_docs.doc_section, pgr_docs.company_name)} style={buttonStyle}>Baixar Documento</Button>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <div style={{ textAlign: 'center' }}>Não há ações disponíveis</div>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={6} style={{ padding: '15px', textAlign: 'center', fontSize: '12px' }}>
                                                Nenhum documento disponível
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </Row>
                    </CardContent>
                ) : nivelAcesso === NiveisAcesso.PARCEIRO || nivelAcesso === NiveisAcesso.CLIENTE ? (
                    <CardContent>
                        <Row className='my-4'>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%'
                            }}>
                                <Title text="Acompanhamento de Documentos" />
                                <Button
                                    style={{
                                        width: '40px',
                                        borderRadius: '20px',
                                    }}
                                    onClick={() => setShowHelp2Modal(true)}>
                                    ?
                                </Button>
                            </Box>
                            <p style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: '0.2%' }}>Ajuda</p>
                        </Row>
                        <Row className='mb-4'>
                        </Row>
                        <Row className='documento-container-cliente'>
                            <table >
                                <thead>
                                    <tr className='documento-tabela-header'>
                                        <th className='documento-tabela-header-celula'>Status</th>
                                        <th className='documento-tabela-header-celula'>Documento</th>
                                        <th className='documento-tabela-header-celula'>Empresa</th>
                                        <th className='documento-tabela-header-celula'>Responsável</th>
                                        <th className='documento-tabela-header-celula'>Status do Documento</th>
                                        <th className='documento-tabela-header-celula'>Data do Envio</th>
                                        <th className='documento-tabela-header-celula'>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data && data.length > 0 ? (
                                        data.map((pgr_docs: any) => {
                                            return (
                                                <tr key={pgr_docs.id}>
                                                    <td className='documento-celula'>
                                                        {pgr_docs.doc_type === StatusDocumento.PENDENTE_ASSINATURA ? (
                                                            <Badge pill className="badge-orange">
                                                                <NewReleasesIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                Aguardando Assinatura
                                                            </Badge>
                                                        ) : pgr_docs.doc_type === StatusDocumento.ASSINADO ? (
                                                            <Badge bg="success" pill style={{ width: '180px' }}>
                                                                <CheckCircleOutlineIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                {pgr_docs.type_name}
                                                            </Badge>
                                                        ) : pgr_docs.doc_type === StatusDocumento.RECUSADO ? (
                                                            <Badge bg="danger" pill style={{ width: '180px' }}>
                                                                <ThumbDownOffAltIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                {pgr_docs.type_name}
                                                            </Badge>
                                                        ) : pgr_docs.doc_type === StatusDocumento.QUARENTENA ? (
                                                            <Badge bg="danger" pill style={{ width: '180px' }}>
                                                                <ContentPasteSearchIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                {pgr_docs.type_name}
                                                            </Badge>
                                                        ) : pgr_docs.doc_type === StatusDocumento.RETORNADO ? (
                                                            <Badge bg="warning" pill style={{ width: '180px' }}>
                                                                <RedoIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                {pgr_docs.type_name}
                                                            </Badge>
                                                        ) : null}
                                                    </td>
                                                    <td className='documento-celula'>
                                                        {pgr_docs.doc_section}
                                                    </td>
                                                    <td className='documento-celula'>
                                                        {pgr_docs.company_name}
                                                    </td>
                                                    <td className='documento-celula'>
                                                        {pgr_docs.responsavel}
                                                    </td>
                                                    <td className='documento-celula'>
                                                        {pgr_docs.doc_type === StatusDocumento.ASSINADO ? (
                                                            `Assinado em ${formatDate(pgr_docs.updated_at)}`
                                                        ) : (
                                                            'Status ainda não estabelecido'
                                                        )}
                                                    </td>
                                                    <td className='documento-celula'>
                                                        {formatDate(pgr_docs.created_at)}
                                                    </td>
                                                    <td
                                                        style={{
                                                            fontSize: '12px',
                                                            padding: '15px',
                                                            borderTop: '1px solid lightgray',
                                                            textAlign: 'center'
                                                        }}
                                                    >
                                                        {pgr_docs.doc_type !== StatusDocumento.QUARENTENA ? (
                                                            <>
                                                                {pgr_docs.doc_type === StatusDocumento.ASSINADO ? (
                                                                    <Button
                                                                        onClick={() => downloadSignedDocument(pgr_docs.id)}
                                                                        style={{
                                                                            width: '180px',
                                                                            height: '40px',
                                                                            fontSize: '13px',
                                                                            display: 'inline-block',
                                                                        }}
                                                                    >
                                                                        Baixar Documento
                                                                        <FileDownloadIcon style={{ marginLeft: '6px' }} />
                                                                    </Button>
                                                                ) : (
                                                                    <p>Aguardando a assinatura do documento</p>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <div>Não há ações disponíveis</div>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={6} style={{ padding: '15px', textAlign: 'center' }}>
                                                Nenhum documento disponível
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </Row>
                    </CardContent>
                ) : (nivelAcesso === NiveisAcesso.ADMIN) && (
                    <>
                        <CardContent>
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%', height: '20px' }}>
                                <div style={{ marginTop: '15px' }}>
                                    <Text text="Empresa" />
                                </div>
                                <Autocomplete
                                    value={selectedCompany}
                                    inputValue={inputValue}
                                    noOptionsText="Digite nome ou CNPJ e selecione"
                                    style={{ width: '400px', height: '35px' }}
                                    renderInput={(params) => (<TextField {...params} label="Digite nome ou CNPJ e selecione" />)}
                                    options={companies}
                                    filterOptions={(options, { inputValue }) => filterOptions(options, inputValue)}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    getOptionLabel={(option: any) => tratarLabelExibicaoAutocomplete(option)}
                                    onChange={(_, newValue) => handleAutocompleteOnChange(newValue)}
                                    onInputChange={(_, inputValue, reason) => handleAutocompleteOnInputChange(inputValue, reason)}
                                />
                            </div>
                        </CardContent>
                        <CardContent>
                            <Row className='my-4'>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%'
                                }}>
                                    <Title text="Acompanhamento de Documentos" />
                                    <Button
                                        style={{
                                            width: '40px',
                                            borderRadius: '20px',
                                        }}
                                        onClick={() => setShowHelp2Modal(true)}>
                                        ?
                                    </Button>
                                </Box>
                                <p style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: '0.2%' }}>Ajuda</p>
                            </Row>
                            <Row className='mb-4'>
                            </Row>
                            <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                <table >
                                    <thead>
                                        <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                            <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal', textAlign: 'center', borderRight: '1px solid white' }}>Status</th>
                                            <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal', textAlign: 'center', borderRight: '1px solid white' }}>Documento</th>
                                            <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal', textAlign: 'center', borderRight: '1px solid white' }}>Empresa</th>
                                            <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal', textAlign: 'center', borderRight: '1px solid white' }}>Responsável</th>
                                            <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal', textAlign: 'center', borderRight: '1px solid white' }}>Data do Envio</th>
                                            <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal', textAlign: 'center', borderRight: '1px solid white' }}>Status do Documento</th>
                                            <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal', textAlign: 'center', borderRight: '1px solid white' }}>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data && data.length > 0 ? (
                                            data.map((pgr_docs: any) => {
                                                return (
                                                    <tr key={pgr_docs.id}>
                                                        <td className='documento-celula'>
                                                            {pgr_docs.doc_type === StatusDocumento.PENDENTE_ASSINATURA ? (
                                                                <Badge pill style={{ width: '180px' }} className="badge-orange">
                                                                    <NewReleasesIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                    {pgr_docs.type_name}
                                                                </Badge>
                                                            ) : pgr_docs.doc_type === StatusDocumento.ASSINADO ? (
                                                                <Badge bg="success" pill style={{ width: '180px' }}>
                                                                    <CheckCircleOutlineIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                    {pgr_docs.type_name}
                                                                </Badge>
                                                            ) : pgr_docs.doc_type === StatusDocumento.RECUSADO ? (
                                                                <Badge bg="danger" pill style={{ width: '180px' }}>
                                                                    <ThumbDownOffAltIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                    {pgr_docs.type_name}
                                                                </Badge>
                                                            ) : pgr_docs.doc_type === StatusDocumento.QUARENTENA ? (
                                                                <Badge bg="danger" pill style={{ width: '180px' }}>
                                                                    <ContentPasteSearchIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                    {pgr_docs.type_name}
                                                                </Badge>
                                                            ) : pgr_docs.doc_type === StatusDocumento.RETORNADO ? (
                                                                <Badge bg="warning" pill style={{ width: '180px' }}>
                                                                    <RedoIcon style={{ fontSize: '20px', marginRight: '5px' }} />
                                                                    {pgr_docs.type_name}
                                                                </Badge>
                                                            ) : (
                                                                'Status ainda não estabelecido'
                                                            )}
                                                        </td>
                                                        <td className='documento-celula'>
                                                            {pgr_docs.doc_section}
                                                        </td>
                                                        <td className='documento-celula'>
                                                            {pgr_docs.company_name}
                                                        </td>
                                                        <td className='documento-celula'>
                                                            {pgr_docs.responsavel}
                                                        </td>
                                                        <td className='documento-celula'>
                                                            {formatDate(pgr_docs.created_at)}
                                                        </td>
                                                        <td className='documento-celula'>
                                                            {pgr_docs.doc_type === StatusDocumento.ASSINADO ? (
                                                                `Assinado em ${formatDate(pgr_docs.updated_at)}`
                                                            ) : (
                                                                `Enviado em ${formatDate(pgr_docs.updated_at)}`
                                                            )}
                                                        </td>
                                                        <td className='documento-celula'>
                                                            <div className='documento-celula-div-flex'>
                                                                {pgr_docs.doc_type === StatusDocumento.ASSINADO ? (
                                                                    <Button onClick={() => downloadSignedDocument(pgr_docs.id)} style={{ width: '180px', height: '40px', fontSize: '13px' }} >
                                                                        Baixar Documento
                                                                        <FileDownloadIcon style={{ marginLeft: '6px' }} />
                                                                    </Button>
                                                                ) : (
                                                                    <Button onClick={() => downloadDocument(pgr_docs.id, pgr_docs.doc_section, pgr_docs.company_name)} style={{ width: '180px', height: '40px', fontSize: '13px' }}>
                                                                        Baixar Documento
                                                                        <FileDownloadIcon style={{ marginLeft: '6px' }} />
                                                                    </Button>
                                                                )}

                                                                {pgr_docs.doc_type === StatusDocumento.QUARENTENA && (
                                                                    <>
                                                                        <Button style={{ ...buttonStyle, width: '180px', height: '40px', fontSize: '13px', background: '#FF0000' }} href={`${pgr_docs.doc_section.toLowerCase()}?empresa=${pgr_docs.company_id}&fdt=${pgr_docs.fdt_id}&revisao=${pgr_docs.revisao_id}`} >Corrigir</Button>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={6} style={{ padding: '15px', textAlign: 'center' }}>
                                                    Nenhum documento disponível
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </Row>
                        </CardContent>
                    </>
                )}
            </Main>
            <Modal
                open={showAccessModal}
                onClose={handleCloseAccessModal}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '400px'
                }}>
                    <input
                        type="file"
                        id="fileInput"
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                    />
                    <label htmlFor="fileInput" style={{
                        border: '2px dashed #0d6efd',
                        padding: '40px',
                        display: 'block',
                        width: 'calc(100% - 40px)',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        cursor: 'pointer',
                        color: '#0d6efd',
                        borderRadius: '4px',
                        margin: '20px 0'
                    }}>
                        {selectedFileName ? `Arquivo selecionado: ${selectedFileName}` : "Clique aqui para anexar o documento"}
                    </label>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        {selectedFileName ? (
                            <Button variant="contained" color="primary" style={{ marginTop: '20px', background: '#009900', color: '#fff' }} onClick={handleFileSave}>
                                Enviar
                            </Button>
                        ) : (
                            <Button variant="contained" color="primary" style={{ marginTop: '20px', background: '#009900', color: '#fff' }} onClick={handleShowAlert}>
                                Enviar
                            </Button>

                        )}
                        {error && (
                            <div className="error-container my-3 text-danger">
                                <img
                                    className="error-icon"
                                    src={errorIcon}
                                    alt="Error" />
                                <p className="error-text text-center mb-3" style={{ fontSize: '15px' }}>{error}</p>
                            </div>
                        )}
                    </Box>
                </Box>
            </Modal>

            <Modal
                open={showHelpModal}
                onClose={handleCloseHelpModal}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '400px',
                    maxWidth: '90%',
                    maxHeight: '80%'
                }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <h4>AJUDA</h4>

                        <p>
                            <strong>Passo 1:</strong> Faça o download do documento e verifique se todas as informações e dados estão corretos.
                        </p>
                        <p>
                            <strong>Passo 2:</strong> Se as informações estiverem corretas, você deverá utilizar o documento que baixou anteriormente e acessar o site do Governo, onde realizará a assinatura do documento.
                            <br />
                            <strong> Observação:</strong> Caso encontre algum problema com o documento, selecione o botão de recusa e informe o motivo da recusa.
                        </p>
                        <p>
                            <strong>Passo 3:</strong> Após a assinatura, você poderá baixar a versão atualizada do documento.
                        </p>
                        <p style={{ color: '#CC0000' }}>
                            Para completar a assinatura do documento, é imprescindível acessar o site oficial do Governo. Este procedimento assegura a autenticação e validação de sua assinatura.
                        </p>
                        <b>Acesse o site do Governo através do link abaixo:</b>
                        <a href='https://www.gov.br/governodigital/pt-br/assinatura-eletronica' target='_blank'>Clique aqui</a>
                    </Box>

                </Box>
            </Modal>
            <Modal
                open={showRejectModal}
                onClose={handleCloseRejectModal}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '400px'
                }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                        <h5>RAZÕES PARA A REJEIÇÃO DO DOCUMENTO </h5>
                        <textarea
                            placeholder='Digite aqui as observações'
                            value={observations}
                            style={{ width: '100%' }}
                            onChange={(e) => setObservations(e.target.value)} />
                        <Button style={{ marginTop: '20px', background: '#009900', color: '#fff', width: '100%' }} onClick={handleRejectDocument}>
                            Enviar
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Modal
                open={showHelp2Modal}
                onClose={handleCloseHelp2Modal}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '400px',
                    maxWidth: '90%',
                    maxHeight: '80%',
                    overflow: 'auto'
                }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                        <h4>AJUDA</h4>
                        <p>
                            <b>Status do Documento:</b>
                        </p>
                        <p>
                            <b>Recusado:</b> Este status indica que o documento passou por uma análise e foi recusado pelo responsável, acompanhado de observações específicas. Para proceder, você deve selecionar a opção <a href='/pgr'><b>"Editar Documento"</b></a>, realizar as correções sugeridas, e então reenviar o documento para nova avaliação.
                        </p>
                        <p>
                            <b>Assinado:</b> O documento foi revisado, aprovado, e assinado pelo responsável. Ele agora está oficialmente validado e pronto para ser utilizado conforme necessário.
                        </p>
                        <p>
                            <b>Pendente de Assinatura:</b> O documento está atualmente em espera para ser analisado e assinado pelo responsável. Este status é um lembrete de que o processo de aprovação ainda está em andamento.
                        </p>
                    </Box>
                </Box>
            </Modal>
            <Modal
                open={progressModalOpen}
                sx={{ display: 'grid', placeItems: 'center' }}

                disableEscapeKeyDown={true}
            >
                <Box sx={{ width: '400px', p: 3, bgcolor: 'background.paper', borderRadius: '5px' }}>
                    <Typography sx={{ textAlign: 'center', paddingbottom: '10px' }}>Assinando e enviando o documento...</Typography>
                    <LinearProgress variant="determinate" value={progressValue} sx={{ height: '5px', borderRadius: '3px' }} />
                </Box>

            </Modal>
        </div >
    );
}